<script>
import { mapState } from 'vuex'
import Rainbow from '@/components/Rainbow.vue'

export default {
  name: 'PlanDetail',
  props: ['id'],
  components: {
    Rainbow,
  },
  computed: {
    ...mapState(['plans']),
    plan() {
      return this.plans.find(plan => plan.id == this.id) || { planCode: '', name: '', costPerMonth: '', headline: '', description: '', }
    },
    bgClass() {
      return `bgClass2`
    },
    bullets() {
      if(typeof this.plan.description == 'string') {
        return this.plan.description.split(' | ').filter(p => p != 'bestvalue')
      }
      return []
    },
    bestValue() {
      if(typeof this.plan.description == 'string') {
        return this.plan.description.split(' | ').includes('bestvalue')
      }
      return false
    }
  },
  mounted() {
    this.$scrollTo(`#app`, 500, { easing: 'ease-in-out', })
  },
  methods: {
    gotoPlan(plan) {
      this.$store.dispatch('signup/SET_STEP', 0)
      this.$store.dispatch('signup/RESET')
      this.$router.push({ path: `/plans/${ plan.id }/signup`})
    }
  },
}
</script>

<template>
  <v-row class="hero" :class="[bgClass]">
    <v-col class="mt-0 pt-0 mb-0 pb-0">
      <v-container fluid class="mt-0 pt-0 topheader">
        <v-row>
          <v-col cols="12" class="ma-0 pa-0">
            <v-row class="mobile-hero">
              <v-col class="my-0 py-0">
                <div class="mobile-hero-img" :class="[bgClass]"></div>
              </v-col>
            </v-row>
          </v-col>
          <v-col md="7" cols="12">
            <v-row
              class="text-left px-4"
            >
              <v-col cols="0" md="2"></v-col>
              <v-col cols="12" md="7" class="header">
                <Rainbow class="ma-0 ml-1" thickness="8px" style="text-align: left; width: 30%;" />
                <h1 class="mb-4">{{ plan.name }}</h1>
                <p>Regular trips to the vet are essential for keeping your pet healthy, but not knowing what those trips will cost can be incredibly stressful and hard to plan for financially. That’s why we’re excited to offer the Essential Care Plan. With <b>unlimited</b> pet exams<sup style="top: -10px !important;">1</sup>included, you don’t have to worry about whether something you want checked out is worth a trip to the vet.  We care about your pet's wellness and your peace of mind.  Plus, with <b>unlimited $5</b> nail trims and a <b>10%</b> discount on <b>all</b> additional services, you don’t have to worry about whether something you want checked out is worth a trip to the vet, you’ll be saving money on every visit — while ensuring your pet receives the veterinary care it deserves. </p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
      <v-row class="details mb-0 pb-0">
        <v-col cols="2"></v-col>
        <v-col align="left" class="pa-12 px-0" cols="8">
          <v-card
            class="elevation-5 flex d-flex flex-column white lighten-1 pa-3 mb-6"
            width="100%"
            height="100%"
          >
            <div v-if="bestValue" class="my-0 py-1 pt-2 bestvalue">BEST VALUE</div>
            <v-card-title primary-title class="mb-2">
              <h3 class="font-weight-bold plan-header mb-0 pa-0">
                {{ plan.name }}
              </h3>
            </v-card-title>
            <v-card-text class="flex">
              <v-divider light class="mb-6"></v-divider>
              <div class="cost">
                <span class="dollarSup">$</span><span>{{ plan.costPerMonth }}</span><span style="top: -20px; position: relative; font-size: 30px;">*</span><span class="mo">/mo</span>
              </div>
              <div>*Requires 12 month commitment.</div>
              <v-divider light class="mt-2 mb-6"></v-divider>
              <div class="mb-6">
                <h3>Plan Headline</h3>
              </div>
              <v-list-item
                v-for="(item, i) in bullets"
                :key="i"
                class="px-0"
              >
                <v-icon class="checkmark mr-2">mdi-check-circle</v-icon> <span class="font-weight-bold">{{ item }}</span>
              </v-list-item>
            </v-card-text>
            <v-card-actions class="d-flex flex-column">
              <v-btn block elevation="0" x-large class="mt-4 greenbtn"
                @click="gotoPlan(plan)"
              >Select Membership</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="2"></v-col>
      </v-row>
      <!--
      <v-row>
        <v-col class="text-center" cols="12 py-12">
          <h1>Lorem Ipsum Dolar</h1>
          <Rainbow class="py-0 my-0 mx-auto" thickness="6px" style="width: 200px; min-width: 200px;" />
          <p style="width: 50%;" class="mx-auto mt-12">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla sagittis magna sed diam iaculis, non volutpat sapien vehicula. Fusce ac lacus et justo mollis tincidunt et ut risus. Nulla luctus tellus molestie, luctus lorem ut, tempus tortor.</p>
        </v-col>
      </v-row>
      -->
    </v-col>
  </v-row>
</template>

<style lang="scss" scoped>
h3 {
  color: $hpp-blue;
}
.header {
  min-height: 450px;
}
.bgClass0 {
  background-image: url('../assets/img/HPP_DetailPg_1.jpg')
}
.bgClass1 {
  background-image: url('../assets/img/HPP_DetailPg_2.jpg')
}
.bgClass2 {
  background-image: url('../assets/img/HPP_DetailPg_3.jpg')
}
@media only screen and (max-width: 960px) {
  .header {
    min-height: 0;
  }
  .hero.bgClass0 {
    background-image: none;
  }
  .hero.bgClass1 {
    background-image: none;
  }
  .hero.bgClass2 {
    background-image: none;
  }
}
.details {
  background-color: $hpp-blue;
}
.plan-header {
  color: $hpp-darkblue;
  font-size: 32px !important;
  white-space: pre-wrap;
  word-break: keep-all;
}
.mo {
  font-size: 24px;
}
.cost {
  color: $hpp-darkgrey;
  font-weight: 500;
  font-size: 64px;
}
.dollarSup {
  vertical-align: top;
  font-size: 24px;
  line-height: 2em;
  top: -20px;
  position: relative;
}
.checkmark {
  color: $hpp-blue !important;
}
.bestvalue {
  text-align: center;
  border-bottom: none;
  border-top-left-radius: 4px !important;
  border-top-right-radius: 4px !important;
  font-size: 16px;
  width: 70%;
  left: 15%;
  top: -36px;
  position: absolute;
  background-color: $hpp-orange;
  color: white;
}
@media only screen and (max-width: 960px) {
  h3 {
    font-size: 28px;
  }
}
</style>
